import React from "react";
import { Button } from "antd";

// Empty-state hint for the Active tab when a search returns no active user.
//
// A deactivated user is absent from the active roster, so searching for them
// reads as "missing". This surfaces the Deactivated tab as the
// place to look — stating whether a match actually lives there — and always
// offers a one-click switch that carries the search term over, so the
// navigation path is consistent whether or not a match exists.
export const SearchMissHint = ({
  searchTerm,
  deactivatedMatchCount = 0,
  onViewDeactivated,
}) => {
  const hasMatch = deactivatedMatchCount > 0;
  const matchPhrase =
    deactivatedMatchCount === 1
      ? "1 deactivated user"
      : `${deactivatedMatchCount} deactivated users`;

  return (
    <div style={{ padding: "24px 16px", fontFamily: "Inter, sans-serif" }}>
      <div style={{ fontSize: "14px", color: "#3f3f46", marginBottom: "12px" }}>
        {hasMatch ? (
          <>
            No active users match <strong>&ldquo;{searchTerm}&rdquo;</strong> —
            but {matchPhrase} do.
          </>
        ) : (
          <>
            No users match <strong>&ldquo;{searchTerm}&rdquo;</strong> in Active
            or Deactivated.
          </>
        )}
      </div>
      <Button
        onClick={onViewDeactivated}
        style={{
          fontFamily: "Inter, sans-serif",
          fontSize: "14px",
          fontWeight: 500,
          color: "#0e49b5",
          borderColor: "#0e49b5",
          borderRadius: "9999px",
          height: "36px",
        }}
      >
        View in Deactivated
      </Button>
    </div>
  );
};
